var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-flex justify-center w-full relative"},[(_vm.isLoading)?_c('div',{staticClass:"absolute inset-0 inline-flex items-center justify-center"},[_c('Spinner',{attrs:{"appearance":"dark"}})],1):_vm._e(),_c('div',{staticClass:"w-full",class:[_vm.$style.element, ( _obj = {}, _obj[_vm.$style.isLoading] = _vm.isLoading, _obj )]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }